/**
 * Exports JSON Schema versions of all Zod schemas for Python consumption.
 * Uses Zod v4's native z.toJSONSchema() (Draft 2020-12).
 */
import { z } from "zod";
import { DocumentChunkSchema, DocumentSchema } from "./document.js";
import { JurisdictionSchema } from "./jurisdiction.js";
import { MeetingSchema } from "./meeting.js";
import { NotificationSchema } from "./notification.js";
import { OrgMemberSchema, OrgSchema } from "./org.js";
import { SavedSearchRunSchema, SavedSearchSchema } from "./saved-search.js";
import { SourceSchema } from "./source.js";
import { UserSchema } from "./user.js";

export const allJsonSchemas = {
  jurisdiction: z.toJSONSchema(JurisdictionSchema),
  source: z.toJSONSchema(SourceSchema),
  meeting: z.toJSONSchema(MeetingSchema),
  document: z.toJSONSchema(DocumentSchema),
  documentChunk: z.toJSONSchema(DocumentChunkSchema),
  user: z.toJSONSchema(UserSchema),
  org: z.toJSONSchema(OrgSchema),
  orgMember: z.toJSONSchema(OrgMemberSchema),
  savedSearch: z.toJSONSchema(SavedSearchSchema),
  savedSearchRun: z.toJSONSchema(SavedSearchRunSchema),
  notification: z.toJSONSchema(NotificationSchema),
} as const;

export type JsonSchemaKey = keyof typeof allJsonSchemas;

/**
 * Returns the JSON Schema object for the given schema name.
 * The returned object contains `type`, `properties`, `required`, etc.
 */
export function getJsonSchema(name: JsonSchemaKey): Record<string, unknown> {
  return allJsonSchemas[name] as Record<string, unknown>;
}

export {
  DocumentChunkSchema,
  DocumentSchema,
  JurisdictionSchema,
  MeetingSchema,
  NotificationSchema,
  OrgMemberSchema,
  OrgSchema,
  SavedSearchRunSchema,
  SavedSearchSchema,
  SourceSchema,
  UserSchema,
};
